$(function() {
  var productJson = $.parseJSON($('#product-json').text()); // get the JSON data describing the product
  var localizedOptions = []; // set up an array to store all our options that need to be localized
  var geolocationData = null; // store the client's geolocation here
  var optionsLocalized = false; // to ensure that we only run the localization function once (to avoid infinite loops when options are selected), we'll set up a flag that will be set to true when the first localization is done successfully. 
  
  // Get the client's geolocation data and store it in the geolocationData variable
  // this uses the ipap.co api, which is limited to 30k requests per month (approx 1k per day). https://ipapi.co/#paid-vs-free
  $.ajax({
    dataType: 'jsonp',
    url: 'https://ipapi.co/jsonp/',
    success: function(data) {
      geolocationData = data;
      
      // just in case this json request finished after the variants were updated, rerun the localization function. 
      localizeOptions();
    }
  });
  
  // when the variant is selected and the theme scripts have finished running through and changing all the selects, we're emitting a custom event. 
  // that event is being triggered from line 4544 of shop.js.liquid
  $(document).on('envision:variant:selected', function(e, variant, container) {
    // first, clear all our event listeners from the localized options that we may have from a previous selection and empty our option array
    localizedOptions = [];
    
    // if we have our JSON of the product, loop through and collect all the options that need to be localized.
    if (productJson) {
      for (var i=0; i<productJson.options.length; i++) {
        
        // if our option has the name "Ship To", we'll need to localize it
        if (productJson.options[i] === "Ship To") { 
          
          // get a reference to the first DOM element associated with the option and store it in an array
          var localizedOption = $('#product-select-option-' + i);
          if (localizedOption.length > 0) {
          	localizedOptions.push($('#product-select-option-' + i).first());
          }
        }
      }
    }
    
    // localize the options we just found. Will only run once, and won't run if the geolocation data isn't loaded yet. 
    localizeOptions();
  });
  
  // this function selects the proper option depending on where the client's IP address is located
  // only runs once per page load. 
  var localizeOptions = function() {
    // if our geolocation data isn't loaded yet, or was blocked, or we haven't loaded any options yet, or we've already localized the options, exit the function early. 
    if (geolocationData === null || localizedOptions.length === 0 || optionsLocalized) {
      return;
    }
    
    optionsLocalized = true; // set the global flag to make sure that we only run this function once. 
    
    // update the options to match the country code
    switch (geolocationData.country) {
      case 'US': // US
        $.each(localizedOptions, function() {
          $(this).val('USA').change();
        });
        break;
      case 'CA': // Canada
        $.each(localizedOptions, function() {
          $(this).val('Canada').change();
        });
        break;
      case 'GB': // United Kingdom
        $.each(localizedOptions, function() {
          $(this).val('United Kingdom').change();
        });
        break;
      case 'AT': // Europe
      case 'BE': 
      case 'HR':
      case 'BG': 
      case 'CY': 
      case 'CZ':
      case 'DK': 
      case 'EE': 
      case 'FI':
      case 'FR': 
      case 'DE': 
      case 'GR': 
      case 'HU': 
      case 'IE': 
      case 'IT': 
      case 'LV': 
      case 'LT':
      case 'LU': 
      case 'MT': 
      case 'NL': 
      case 'PL':
      case 'PT': 
      case 'RO': 
      case 'SK': 
      case 'SI': 
      case 'ES':
      case 'SE':
        $.each(localizedOptions, function() {
          $(this).val('Europe').change();
        });
        break;
    }
  };
});